import Skeleton from "react-loading-skeleton";

const MessagesBoxSkeleton = () => {
    return (
        <div className="messages-box list-group">
            <ul className="messages-list">
                {Array.from({ length: 10 }).map((_, i) => (
                    <div key={i} className="list-group-item">
                        <Skeleton className="chat-thumbnail" width="45px"/>
                        <div className="skeleton-message-box-text" style={{"flexGrow":"1"}}>
                            <Skeleton width="50%" height="20%" />
                            <Skeleton width="75%" height="30%"/>
                        </div>
                    </div>
                ))}
            </ul>
        </div>
    )
}
export default MessagesBoxSkeleton
